import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { CheckboxComponent } from '../checkbox/checkbox.component';

@Component({
  selector: 'app-map-layers-modal',
  templateUrl: './map-layers-modal.component.html',
  styleUrls: ['./map-layers-modal.component.scss'],
  standalone: true,
  imports: [DialogModule, InputSwitchModule, CheckboxComponent, ButtonModule, FormsModule, CommonModule]
})
export class MapLayersModalComponent {
  @Input() visible = false;
  @Input() latitude!: number;
  @Input() longitude!: number;

  @Input() selectedMapType = 'streets';
  @Input() showEvacuationRadius = false;
  @Input() showSwimLanes = false;
  @Input() showPendingEvents = true;
  @Input() showCompletedEvents = true;
  @Input() showEventsOutsideView = true;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() apply = new EventEmitter<{
    selectedMapType: string;
    showEvacuationRadius: boolean;
    showSwimLanes: boolean;
    showPendingEvents: boolean;
    showCompletedEvents: boolean;
    showEventsOutsideView: boolean;
  }>();

  getMapboxPreviewURL(mapType: string) {
    const mapStyles: { [key: string]: string } = {
      satellite: 'mapbox/satellite-v9',
      streets: 'mapbox/streets-v11',
      terrain: 'mapbox/outdoors-v11'
    };
    const style = mapStyles[mapType];
    return `https://api.mapbox.com/styles/v1/${style}/static/${this.longitude},${this.latitude},12/200x200?access_token=${environment.mapboxAccessToken}`;
  }

  selectMapType(type: string) {
    this.selectedMapType = type;
  }

  onCancel() {
    this.visibleChange.emit(false);
  }

  onApply() {
    this.apply.emit({
      selectedMapType: this.selectedMapType,
      showEvacuationRadius: this.showEvacuationRadius,
      showSwimLanes: this.showSwimLanes,
      showPendingEvents: this.showPendingEvents,
      showCompletedEvents: this.showCompletedEvents,
      showEventsOutsideView: this.showEventsOutsideView
    });
    this.visibleChange.emit(false);
  }
}
